import { Component, Mixins } from "vue-property-decorator";
import CrkClient from "@/mixins/crk/crk-client";
import NotificationCore from "@/modules/NotificationCore/NotificationCore";
import AppConfig from "@/core/app.config";
import TimerUtils from "@/modules/Timer/TimerUtils";
import { DigitalSignResult, SignTimerId } from "./interface";

import { Mutation } from "vuex-class";
import { LOADING_MODULE_NAME } from "@/store/modules/loading";
import { DigitalSign } from "@/feature/Auth/types/digital-sign";
import { IGetServerToken } from "@/api/e-imzo/interface";
import { $getTokenCrkByPayment } from "@/api/e-imzo";

@Component
export default class Crk extends Mixins(CrkClient) {

	@Mutation('setActive', { namespace: LOADING_MODULE_NAME })
	setLoading!: (value: boolean) => void

	sign: string = '';

	serverToken: string = ''//'jcgHsjP1oy9+VNOTVtmHT1dVHyLK2ejM5YNqRLg4t90dtTe85KHOtjgHqGKRWCyT0HslFw==';

	text: string = 'Text';

	userKey: any = null;

	list: any = [];

	crkDialogIsActive: boolean = false;

	crkSignature: any = {};

	signKeysPingDelayInMs: number = 1000

	async setTimeoutForPingKeysList(timerId: SignTimerId) {
		timerId.id === null && await this.pingSignKeysList();

		timerId.id = setTimeout(async () => {
			await this.pingSignKeysList();

			timerId.id === null || this.setTimeoutForPingKeysList(timerId);
		}, this.signKeysPingDelayInMs);
	}

	infinityPingKeysList(): (() => void) {
		const timerId: SignTimerId = { id: null };

		this.isLoaded = false;
		this.isConnected = false;

		this.setTimeoutForPingKeysList(timerId);

		return () => {
			timerId.id === null || clearTimeout(timerId.id);

			timerId.id = null;
		};
	}

	async pingSignKeysList(): Promise<any[]> {
		const list: any[] = await this.callbackIsignerConnected();

		this.isLoaded = true;

		if (!list.length) {
			await TimerUtils.sleep(this.signKeysPingDelayInMs);

			return this.pingSignKeysList();
		}

		return list;
	}

	callbackIsignerConnected(loading: boolean = false): Promise<any[]> {
		this.errorMessage = "";

		loading && this.setLoading(true);

		return this.iSignerListKeys().then(r => {
			loading && this.setLoading(false);
			AppConfig.eImzoLogging && console.log(r, 'key_list');

			return this.callbackIsignerListkeys(r);
		});
	}

	callbackIsignerListkeys(list: any[]): any[] {
		this.list = [];

		if (list != null && list.length > 0) {
			for (let i = 0; i < list.length; i++) {
				let subject = list[i];

				let x500name_ex = subject
				x500name_ex = x500name_ex.replace("1.2.860.3.16.1.1=", "INN=");
				x500name_ex = x500name_ex.replace("1.2.860.3.16.1.2=", "PINFL=");

				const fullCrmId = x500name_ex.match(/(1\.2\.860\.3\.16\.1\.25=([0-9]+);)/gi);
				let crmId = '';
				let flCrmId = 0;
				let ulCrmId = 0;

				if (fullCrmId) {
					crmId = fullCrmId[0]?.split('=')?.pop()?.slice(0, -1);

					if (crmId) {
						flCrmId = +crmId.slice(0, 10);
						ulCrmId = +crmId.slice(10);
					}
				}

				if (!flCrmId || !ulCrmId) continue;

				let vo = {
					serialNumber: this.iSignerGetSubjectField(x500name_ex, "SERIALNUMBER"),
					validFrom: new Date(this.iSignerGetSubjectField(x500name_ex, "VALIDFROM").replace(/\./g, "-").replace(" ", "T")),
					validTo: new Date(this.iSignerGetSubjectField(x500name_ex, "VALIDTO").replace(/\./g, "-").replace(" ", "T")),
					name: this.iSignerGetSubjectField(x500name_ex, "CN"),
					TIN: (this.iSignerGetSubjectField(x500name_ex, "INN") ? this.iSignerGetSubjectField(x500name_ex, "INN") : this.iSignerGetSubjectField(x500name_ex, "UID")),
					UID: this.iSignerGetSubjectField(x500name_ex, "UID"),
					PINFL: this.iSignerGetSubjectField(x500name_ex, "PINFL"),
					firm: this.iSignerGetSubjectField(x500name_ex, "O"),
					role: this.iSignerGetSubjectField(x500name_ex, "TITLE"),
					iKey: this.iSignerGetSubjectField(x500name_ex, "I-KEY:")
						|| this.iSignerGetSubjectField(x500name_ex, "E-PASS:"),
					flCrmId,
					ulCrmId
					// type: "pfx"
				};

				this.list.push(vo)
			}
		}

		return this.list;
	}

	async signObject<T>(
		data: T,
		digitalSign: DigitalSign,
		password: string
	): Promise<DigitalSignResult> {
		// mock
		// return {
		// 	result: {
		// 		base64ToString: 'base64ToString',
		// 		sign: 'sign'
		// 	}
		// };

		const dataString = btoa(unescape(encodeURIComponent(JSON.stringify(data))));

		return this.iSignerHash(dataString, 0)
			.then((hash: string) => {
				const commonError = {
					error: this.$t('crk.errorConfirmCrk') as string
				};

				if (!hash) return commonError;

				return $getTokenCrkByPayment()
					.then((i: IGetServerToken) => {
						if (!i || !i.token) return commonError;

						return this.iSignerCheck(digitalSign, hash, i.token, password)
							.then(arr => {
								if (this.validObjectSign(arr)) return commonError;

								arr.base64ToString = dataString;
								arr.hash = hash;

								return { result: arr };
							});
					});
			});
	}

	validObjectSign(obj: any) {
		AppConfig.eImzoLogging && console.log(obj, 'validObjectSign')

		let sign = obj.sign;
		// this.certificate = obj.cert;

		// sign notFound
		if (sign == null || sign.length == 0) {
			NotificationCore.addToast(this.$t('crk.errorConfirmCrk') as string, 'error');

			return true;
		}

		this.sign = obj.sign;
	}

	iSignerCheck(selected: any, hash: string, serverToken: string, password?: string): Promise<any> {
		return new Promise(resolve => {
			if (hash == null || hash.length == 0) {
				NotificationCore.addToast(this.$t('crk.errorConfirmCrk') as string, 'error');

				return;
			}

			if (selected.name.length == 0) {
				NotificationCore.addToast(this.$t('crk.errorKeyCrk') as string, 'error');

				return;
			}

			let iKey = selected.iKey;

			this.iSignerSign(serverToken, hash, iKey, resolve, password);
		})
	}

	get isEmptyList(): boolean {
		return !this.list?.length
			&& this.isLoaded
			&& this.isConnected
			&& !this.isError;
	}

}